import { FC } from 'react';
import { Alert, Typography } from '@mui/material';
import { useListContext } from 'framework/list';
import { EmployeeLink } from 'domain/shared/employee';
import ProjectHeatmap from './ProjectHeatmap';
import type { HeatmapRowData, HeatmapTimelineData } from '../types';

const renderProjectRowLabel = (row: HeatmapRowData) =>
  row.linkId ? (
    <EmployeeLink id={row.linkId} name={row.label} />
  ) : (
    <Typography variant="body1" color="textSecondary">
      {row.label}
    </Typography>
  );

const ProjectHeatmapWrapper: FC = () => {
  const { data } = useListContext();
  const heatmapData = (data as { heatmapData?: HeatmapTimelineData | null })?.heatmapData ?? null;

  if (!heatmapData) {
    return <Alert severity="info">No records found</Alert>;
  }

  return <ProjectHeatmap data={heatmapData} renderRowLabel={renderProjectRowLabel} />;
};

export default ProjectHeatmapWrapper;
